import React, { useMemo } from 'react';

import { PropsOf } from 'app/@types/utils/props-of';
import useIsMobile from 'hooks/use-is-mobile';
import Carousel from 'main/components/Carousel';
import Title from 'pages/Landings/components/Title';

import AdobeIcon from './assets/adobe.svg';
import AlertLogicIcon from './assets/alert-logic.svg';
import CloudLinuxIcon from './assets/cloud-linux.svg';
import CybersicherheitIcon from './assets/cybersicherheit.svg';
import InavistieIcon from './assets/inavistie.svg';
import PlayrixIcon from './assets/playrix.svg';
import RingCentralIcon from './assets/ring-central.svg';
import SemrushIcon from './assets/semrush.svg';
import Soft2BetIcon from './assets/soft-2-bet.svg';
import VulcanIcon from './assets/vulcan.svg';
import useStyles from './styles';

interface Props {
    title?: Omit<PropsOf<typeof Title>, 'variant'>;
    className?: string;
}

const Customers: React.FC<Props> = ({ title, className }) => {
    const { classes, cx } = useStyles();
    const isMobile = useIsMobile();

    const items = useMemo(
        () =>
            [
                AlertLogicIcon,
                CloudLinuxIcon,
                CybersicherheitIcon,
                InavistieIcon,
                PlayrixIcon,
                RingCentralIcon,
                SemrushIcon,
                Soft2BetIcon,
                AdobeIcon,
                VulcanIcon
            ].map((Icon, index) => (
                <span key={index} className={classes.item}>
                    <Icon />
                </span>
            )),
        [classes.item]
    );
    return (
        <div className={cx(classes.root, className)}>
            <Title {...title} variant="h2">
                {'Trusted by leading companies'}
            </Title>
            {isMobile ? (
                <Carousel className={classes.carousel} gap={20} direction="rtl">
                    {items}
                </Carousel>
            ) : (
                <div className={classes.grid}>{items}</div>
            )}
        </div>
    );
};

export default Customers;
